<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
      <img class="focus-acts-logo" :src="image" />
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in filteredSidebarLinks"
                        :key="link.name + index"
                        :link="link"
                        >

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>

      <div
        class="text-center"
        v-show="isOneOfTheseRoles(['guest'])"
      >
            <el-tooltip
              :open-delay="300"
              placement="top"
            >
              <div slot="content">
                If you are a bible study leader on your campus and<br/>
                expect to see bible studies, please make sure you are<br/>
                logging in with the same email that you have previously<br/>
                used (i.e. if you typically log in with your .edu email,<br/>
                please make sure you are logged in with that email now).
              </div>
              <el-button class="fake-btn">
                Missing tabs?<i class="el-icon-info" style="margin-left: 10px;"/>
              </el-button>
            </el-tooltip>
      </div>

    </div>
          <div class="sidebar-background"></div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  import image from '../../../../public/static/img/background/actslogo.png'
  export default {
    data: function() {
      return {
        image: image
      }
    },
    props: {
      title: {
        type: String,
        default: 'Acts',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'focus-blue-transparent',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black', 'sidebar-image', 'focus-blue-transparent']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'white-color',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger', 'focus-blue', 'white-color']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: 'static/img/vue-logo.png',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      filteredSidebarLinks: function () {
        const isGuest = this.isOneOfTheseRoles(['guest']);

        if(isGuest) {
          return [{
              name: 'Pray Meditations',
              icon: 'nc-icon nc-sun-fog-29',
              path: '/meditations'
          }];
        }
        return this.sidebarLinks.filter(c => 
          (typeof c.meta !== 'undefined') ? (
            c.roleFunction === 'parishOnly' ? this.isOneOfTheseParishRoles(c.meta) :
            this.isOneOfTheseRoles(c.meta)
          ) : true);
      },
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        //eslint-disable-next-line
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
  .sidebar-background {
    background-image: url("../../../../public/static/img/background/adoration-sidebar.jpg");
  }
  .focus-acts-logo {
    max-width: 50%;
    border-radius: 3px;
    margin: auto;
    display: block;
  }
</style>
<style scoped>
.fake-btn {
  border: none;
  background-color: transparent;
  color: white;
  cursor: default;
}
</style>